import React from 'react';
import { DatePickerBase } from './DatePickerBase';
export function DatePicker(props) {
  return /*#__PURE__*/React.createElement(DatePickerBase, props);
}